import gql from "graphql-tag"

import image from "../image"

const mas = gql`
  ${image}

  fragment MAS on MAS {
    actors
    country
    director
    id
    imdbId
    language
    plot
    poster {
      ...Image
    }
    rating
    releaseDate
    runtime
    title
    writer
    year
  }
`

export default mas
